import { noneDigitsDataType } from '@/shared/SelectData'
import { checkDigits } from '@/utils/dataType'
import { getFormatMessage } from '@/utils/utils'
import { message } from 'antd'
import React, { useState } from 'react'
import {
  TemplateReferenceItem,
  TemplateVariableProps,
  VariableItem
} from '../interface'
import { TemplateVariableEditModal } from './edit/modal'
import { TemplateVariableTable } from './table'
import { TemplateVariableToolbar } from './toolbar'

export const TemplateVariable: React.FC<TemplateVariableProps> = (
  props: TemplateVariableProps
) => {
  const { onDelete, onRefRelease } = props
  const [visible, setVisible] = useState<boolean>(false)
  const [variableItem, setVariableItem] = useState<VariableItem>()
  const [batch, setBatch] = useState<boolean>(false)
  const [selected, setSelected] = useState<VariableItem[]>([])
  const [references, setReferences] = useState<TemplateReferenceItem[]>([])
  const formatMessage = getFormatMessage()

  const validateFormData = (item?: VariableItem): boolean => {
    const exist = props.data?.find(
      (x) => x.name == item?.name && x.id != item?.id
    )
    if (exist) {
      message.error(formatMessage({ id: 'app.template.variable.existName' }))
      return false
    }

    if (
      !noneDigitsDataType.includes(item?.dataType!) &&
      !checkDigits(
        item?.dataType!,
        item?.integerDigits || 0,
        item?.fractionDigits || 0
      )
    ) {
      return false
    }

    return true
  }

  const handleFormValidate = (ok: boolean, item?: VariableItem): boolean => {
    if (ok && validateFormData(item)) {
      return true
    }
    return false
  }

  const handleCreate = (batch: boolean) => {
    if (!props.plcs || props.plcs.length <= 0) {
      message.warning(formatMessage({ id: 'app.template.variable.plcEmpty' }))
      return
    }
    console.log(batch)
    setBatch(batch)
    const deviceId = props.plcs
      ? props.plcs.find((x) => x.deviceMode == 0)?.id
      : ''

    const item = {
      deviceId: deviceId,
      privilege: 4,
      dataType: 0,
      mainAddress: 1,
      subAddress: 0,
      subIndex: 0,
      deadZone: 0,
      integerDigits: 4,
      fractionDigits: 0,
      bitIndex: 0,
      stringSetting: {
        encoding: 1,
        charCount: 1
      },
      valueTransform: {
        type: 0
      }
    }
    if (batch) {
      item['batch'] = {
        type: 0,
        increment: 1,
        count: 2
      }
    }
    setReferences([])
    setVariableItem(item)
    setVisible(true)
  }

  const handleEdit = (item: VariableItem) => {
    const refs = props.onRefCheck?.([item])
    setReferences(refs || [])
    setVariableItem(item)
    setVisible(true)
    setBatch(false)
  }

  const handleDelete = (item: VariableItem) => {
    onDelete?.([item])
  }

  const handleBatchDelete = async () => {
    if (!selected || selected.length <= 0) {
      return
    }
    const result = await onDelete?.(selected)
    if (result) {
      setSelected([])
    }
  }

  const handleRefRelease = (item: TemplateReferenceItem) => {
    if (!variableItem) return
    const refs = onRefRelease?.([variableItem], item)
    setReferences(refs || [])
  }

  return (
    <div>
      <TemplateVariableToolbar
        {...props}
        selectable={selected.length > 0}
        onCreate={handleCreate}
        onBatchDelete={handleBatchDelete}
      />
      <TemplateVariableTable
        {...props}
        selectable
        selectionType='checkbox'
        onEdit={handleEdit}
        onDelete={handleDelete}
        onSelect={setSelected}
      />
      <TemplateVariableEditModal
        references={references}
        visible={visible}
        batch={batch}
        editItem={variableItem}
        plcs={props.plcs}
        onVisibleChange={setVisible}
        onFormValidate={handleFormValidate}
        onFormSubmit={props.onFormSubmit}
        onRefRelease={handleRefRelease}
      />
    </div>
  )
}
